import { render, staticRenderFns } from "./radish-detail-tab.vue?vue&type=template&id=57399c3e"
import script from "./radish-detail-tab.vue?vue&type=script&lang=js"
export * from "./radish-detail-tab.vue?vue&type=script&lang=js"
import style0 from "./radish-detail-tab.vue?vue&type=style&index=0&id=57399c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports